import ReactDOM from 'react-dom';
import App from './App';
import './fonts/circular-std-font-family/CircularStd-Bold.ttf';
import 'index.css';

ReactDOM.render(<App />, document.getElementById('root'));
